import * as React from 'react';
import classNames from 'classnames';

/* interface MultiCheckbox_Props {
		*			options: [{id: number, label: string}];
		*			onBlur: Function;
		*			onChange: Function;
		*			onBlur: Function;
		*			onChange: Function;
		*			value: Function;
		*			initialValue: Function;
		* }
* */

import uniq from 'lodash/uniq';
import without from 'lodash/without';
import Checkbox from 'material-ui/Checkbox';
class MultiCheckbox extends React.Component<any,any> {
		modifyValue(event, id) {
				const current_value = this.props.input.value;

				if ( event.target.checked ) { return uniq([...current_value, id]).sort(); }
				return without(current_value, id);
		}

		isChecked(id) {
				return this.props.input.value.indexOf(id) > -1;
		}

		render() {
				const {options, className, input: {onChange, onBlur, value, name}, ...rest} = this.props;
				const checkboxes = options.map(option => (
						<li key={option.id} className='checkbox'>
							<Checkbox
									name={name}
										label={option.name}
										checked={this.isChecked(option.id)}
										onCheck={event => onChange(this.modifyValue(event, option.id))}
										onBlur={() => onBlur(value)}
										{...rest}
								/>
						</li>
				));

				return (
						<ol className={classNames('checkboxes', className)}>
								{checkboxes}
						</ol>
				);
		}
}

/* <input
 * type="checkbox"
 * {...rest}
 * onChange={event => this.handleChange(event, option.id)}
 * onBlur={() => onBlur(values)}
 * checked={isChecked}
 * value={option.id}
 * />
 * */

export default MultiCheckbox;



// WEBPACK FOOTER //
// ./src/app/components/MultiCheckbox.tsx